import { ArticleHeading2, Image, useDeviceType } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';
import { IDealStepCardProps } from '../DealStepCard';

import * as styles from './styles.css';

export const DealStepCardLast: React.FC<IDealStepCardProps> = props => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  return (
    <div className={cn(styles['last-card'], styles[deviceType])}>
      <div className={styles['image']}>
        <Image
          sources={[{ srcset: props.imageX2Src, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX2Src }]}
          src={props.imageX1Src}
          width={isDesktop ? 250 : 140}
          height="auto"
          loading="lazy"
        />
      </div>
      <div className={cn(styles['text-content'], styles[deviceType])}>
        <ArticleHeading2 as="h3">{props.heading}</ArticleHeading2>
        {props.description}
      </div>
    </div>
  );
};
